import React from "react";

// React 19 natively hoists <title>, <meta> and <link> to <head> when rendered
// anywhere in the tree — no react-helmet needed (helmet-async is not React 19
// compatible). JSON-LD is rendered in-document, which Google reads fine.
export default function SEO({ title, description, path = "", type = "website", image, jsonLd }) {
  const base = "https://www.voiceoverkids.agency";
  const url = base + path;
  const fullTitle = title ? `${title} | VoiceOverKids` : "VoiceOverKids — Real Kids. Real Voices. Worldwide.";
  const desc = description || "The specialist international agency for professional children's voices. Find, listen to and cast real child voice actors in 30+ languages.";
  const img = image ? (image.startsWith("http") ? image : base + image) : `${base}/logo.png`;
  const blocks = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:image" content={img} />
      {blocks.map((b, i) => (
        <script key={i} type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(b) }} />
      ))}
    </>
  );
}
